import axios from 'axios'

const userAuthenticateApi = axios.create({
  baseURL: process.env.API_AUTH_USER_URL,
  headers: {
    'Content-Type': 'application/json; charset=UTF-8',
    'Accept': 'application/json; charset=UTF-8',
    'Accept-Language': 'it-IT',
    'Api-Key': process.env.API_GATEWAY_API_KEY
  },
})

export default userAuthenticateApi